export const cartConstants = {
    CART_PROCESS_START: 'cart:start',
    CART_PROCESS_STOP: 'cart:stop',
    CART_LIST: 'cart:list',
    CART_ADD: 'cart:add',
    CART_UPDATE: 'cart:update',
    CART_REMOVE: 'cart:delete',
    CART_REMOVE_All: 'cart:delete:all',
    CART_CLEAR: 'cart:clear',
}